import React from 'react';

const MainProductCard = ({ prdCards, cardId }) => {

  const prdCardWrap = {
    width: '294px',
    height: '303px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '40px',
    margin: '20px',
    color: prdCards.color,
    backgroundColor: prdCards.backgroundColor
  };
  return (
    <div style={prdCardWrap} id={cardId} className={prdCards.wrapClass}>
      <div className={prdCards.innerDivClass}>
        <div className={prdCards.imgClass}>
          <img src={prdCards.imgPath}/>
        </div>
        <div className={prdCards.contentClass}>
          <div className={prdCards.titleClass}>
            {prdCards.title}
          </div>
          {prdCards.content}
        </div>
      </div>
    </div>
  );
}

export default MainProductCard;
